export const headerConstants = { 
    LOGOUT: 'LOGOUT', // Will reset everything
    HARD_RESET: 'HARD_RESET', // Will reset everything except login state
    SOFT_RESET: 'SOFT_RESET' // Will reset everything except login and leadCustomers state
}